<template>
  <div id="section">
    <tb
      :t-btxt1="p17ssubtitlep4"
      :t-btxt2="p17ssubtitlep5" 
      :t-button1="p17ssubtitlep6"
      :t-button2="p17ssubtitlep7" 
      :t-burl="p17surl"
    />
  </div>
</template>

<i18n>
{
  "en":{
    "p17ssubtitlep4": "Contact us to publish an internship offer",
    "p17ssubtitlep5": "It is as simple as completing the form, write or call us. We will help you.",
    "p17ssubtitlep6": "Post publish ",
    "p17ssubtitlep7": "your internship offer"
  },
  "es":{
    "p17ssubtitlep4": "Contáctanos para publicar una oferta de prácticas en empresas",
    "p17ssubtitlep5": "Es tan simple como completar el formulario, escribirnos o llamarnos. Nosotros te ayudaremos.",
    "p17ssubtitlep6": "Publica gratuitamente",
    "p17ssubtitlep7": "Tu oferta de prácticas en empresas"
  }
}
</i18n>

<script>
import tb from "@/components/utils/temp_boton";
export default {
    components: {
        tb
    },
    data() {
        return {
            p17surl: "https://jobs.aicad.es"
        }
    },
    computed: {
        p17ssubtitlep4() {
            return this.$t("p17ssubtitlep4");
        },
        p17ssubtitlep5() {
            return this.$t("p17ssubtitlep5");
        },
        p17ssubtitlep6() {
            return this.$t("p17ssubtitlep6");
        },
        p17ssubtitlep7() {
            return this.$t("p17ssubtitlep7");
        }
    }
};
</script>

<style>

</style>
